import { CmsObjectWithDefault } from '@components/Cms/types';

export type PasskeyEditPopupCmsKey = 'PasskeyName' | 'EditYourPasskey' | 'Save' | 'ValidationError' | 'Cancel';

export const PasskeyEditPopupCmsWithDefault: CmsObjectWithDefault<PasskeyEditPopupCmsKey> = {
    PasskeyName: {
        cmsId: 553058,
        defaultTranslation: 'Passkey name',
    },
    EditYourPasskey: {
        cmsId: 553059,
        defaultTranslation: 'Edit your passkey name',
    },
    Save: {
        cmsId: 553060,
        defaultTranslation: 'Save',
    },
    ValidationError: {
        cmsId: 553064,
        defaultTranslation: 'Only letters, numbers, and spaces are allowed.',
    },
    Cancel: {
        cmsId: 155933,
        defaultTranslation: 'Cancel',
    },
};
